// extracted by mini-css-extract-plugin
export default {"keyOperationalMetricsGrid":"KeyOperationalMetrics_keyOperationalMetricsGrid__irSnT","lightWeight":"KeyOperationalMetrics_lightWeight__9Jo-y"};